export default "__VITE_ASSET__eEtuLBkA__"